// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
  background-color: #ffeddd;
}

.App-all {
  background-color: #b0e0e6; /* black;*/
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: black;
  /*max-width: 100vh;*/
}

.container_small {
  background-color: #b0e0e6; /*rgb(0, 255, 0);*/
  display: flex;
  justify-content: center; /* Center the container content horizontally */
  align-items: center; /* Center items vertically within the container */
  flex-wrap: nowrap; /* Prevent items from wrapping to the next line */
}

.container {
  background-color: #b0e0e6; /* red;*/
  display: flex;
  justify-content: center; /* Center the container content horizontally */
  align-items: center; /* Center items vertically within the container */
  flex-wrap: nowrap; /* Prevent items from wrapping to the next line */
  min-height: 100vh;
  max-width: 100vh;
}




.App-picture {
  background-color: #b0e0e6;
  
  max-width: 140vh;
  display: flex;
  align-items: center; /* Center items vertically within the picture */
  justify-content: center; /* Center items horizontally within the picture */
  flex-direction: column;
  color: black;
}


.App-center {
  max-width: 90%;
  background-color: #ffeddd;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center; /* Center vertically */
  font-size: 20px;
  padding: 10px; /* Add padding inside the border */
  margin: 10px; /* Add margin outside the border */
  text-align: justify; /* Justify text */
  border-radius: 20px; /* Rounded corners */
}

.App-center:after {
  content: '';
  display: inline-block;
  width: 100%; /* Ensures the last line is justified */
}






.App-button-bar {
  background-color: #b0e0e6;
  display: flex; /* Change to flex to use flex properties correctly */
  flex-direction: column;
  align-items: center; /* Center items horizontally within the button bar */
  justify-content: center; /* Center items vertically within the button bar */
  color: black;
}

.App-button {
  background-color: #ffeddd; /* Button background color */
  border: none;
  flex-direction: row;
  padding: 10px; /* Padding inside the button */
  cursor: pointer; /* Cursor on hover */
  border-radius: 32px; /* Rounded corners */
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px; /* Set desired width */
  height: 64px; /* Set desired height */
  margin: 5px; /* Adjust the value as needed */
}

.button-image {
  width: 40px; /* Adjust size as needed */
  height: 40px; /* Adjust size as needed */
}

.App-button:hover {
  color: #0b55d4; /* Darker color for hover effect */
}

.content-wrapper {
  display: flex;
  align-items: center;
}

.left-image {
  width: 250px; /* Adjust the size as needed */
  height: auto;
  object-fit: cover;
  margin-right: 20px; /* Space between image and content */
  border-radius: 150px; /* Adjust this value for the desired roundness */
}

.content {
  font-size: 16px; /* Adjust text size as needed */
  text-align: left;
}

.website-text {
  font-size: 16px; /* Adjust text size as needed */
  text-align: center;
}

.cursive-text {
  font-style: italic; /* Makes the text cursive */
  font-size: 14px; /* Adjust text size as needed */
  text-align: left;
  margin-left:0vh;
}


header {
  margin: 0; /* Remove default margin */
  padding: 10px; /* Optional: Add padding */
}


/* Media query for mobile devices */
@media (max-width: 768px) {
  .container {
    flex-direction: column;
  }

  .App-center {
    order: 3;
    margin-top: 20px;
  }
}



/* Media query for desktop devices */
@media (min-width: 769px) {
  .container {
    flex-direction: row;
  }
  .container_small {
    flex-direction: column;
    
  }
  .App-button-bar {
    flex-direction: row;
  }
  .App-center {
    order: 2; /* Ensure this comes after .App-picture and .App-button-bar */
    margin-left: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB,EAAE,UAAU;EACrC,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,yBAAyB,EAAE,kBAAkB;EAC7C,aAAa;EACb,uBAAuB,EAAE,8CAA8C;EACvE,mBAAmB,EAAE,iDAAiD;EACtE,iBAAiB,EAAE,iDAAiD;AACtE;;AAEA;EACE,yBAAyB,EAAE,QAAQ;EACnC,aAAa;EACb,uBAAuB,EAAE,8CAA8C;EACvE,mBAAmB,EAAE,iDAAiD;EACtE,iBAAiB,EAAE,iDAAiD;EACpE,iBAAiB;EACjB,gBAAgB;AAClB;;;;;AAKA;EACE,yBAAyB;;EAEzB,gBAAgB;EAChB,aAAa;EACb,mBAAmB,EAAE,+CAA+C;EACpE,uBAAuB,EAAE,iDAAiD;EAC1E,sBAAsB;EACtB,YAAY;AACd;;;AAGA;EACE,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB,EAAE,sBAAsB;EAC/C,eAAe;EACf,aAAa,EAAE,kCAAkC;EACjD,YAAY,EAAE,kCAAkC;EAChD,mBAAmB,EAAE,iBAAiB;EACtC,mBAAmB,EAAE,oBAAoB;AAC3C;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,WAAW,EAAE,uCAAuC;AACtD;;;;;;;AAOA;EACE,yBAAyB;EACzB,aAAa,EAAE,oDAAoD;EACnE,sBAAsB;EACtB,mBAAmB,EAAE,oDAAoD;EACzE,uBAAuB,EAAE,kDAAkD;EAC3E,YAAY;AACd;;AAEA;EACE,yBAAyB,EAAE,4BAA4B;EACvD,YAAY;EACZ,mBAAmB;EACnB,aAAa,EAAE,8BAA8B;EAC7C,eAAe,EAAE,oBAAoB;EACrC,mBAAmB,EAAE,oBAAoB;EACzC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW,EAAE,sBAAsB;EACnC,YAAY,EAAE,uBAAuB;EACrC,WAAW,EAAE,+BAA+B;AAC9C;;AAEA;EACE,WAAW,EAAE,0BAA0B;EACvC,YAAY,EAAE,0BAA0B;AAC1C;;AAEA;EACE,cAAc,EAAE,kCAAkC;AACpD;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY,EAAE,8BAA8B;EAC5C,YAAY;EACZ,iBAAiB;EACjB,kBAAkB,EAAE,oCAAoC;EACxD,oBAAoB,EAAE,gDAAgD;AACxE;;AAEA;EACE,eAAe,EAAE,+BAA+B;EAChD,gBAAgB;AAClB;;AAEA;EACE,eAAe,EAAE,+BAA+B;EAChD,kBAAkB;AACpB;;AAEA;EACE,kBAAkB,EAAE,2BAA2B;EAC/C,eAAe,EAAE,+BAA+B;EAChD,gBAAgB;EAChB,eAAe;AACjB;;;AAGA;EACE,SAAS,EAAE,0BAA0B;EACrC,aAAa,EAAE,0BAA0B;AAC3C;;;AAGA,mCAAmC;AACnC;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,QAAQ;IACR,gBAAgB;EAClB;AACF;;;;AAIA,oCAAoC;AACpC;EACE;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;;EAExB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,QAAQ,EAAE,6DAA6D;IACvE,iBAAiB;EACnB;AACF","sourcesContent":[".App {\n  text-align: center;\n  background-color: #ffeddd;\n}\n\n.App-all {\n  background-color: #b0e0e6; /* black;*/\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  color: black;\n  /*max-width: 100vh;*/\n}\n\n.container_small {\n  background-color: #b0e0e6; /*rgb(0, 255, 0);*/\n  display: flex;\n  justify-content: center; /* Center the container content horizontally */\n  align-items: center; /* Center items vertically within the container */\n  flex-wrap: nowrap; /* Prevent items from wrapping to the next line */\n}\n\n.container {\n  background-color: #b0e0e6; /* red;*/\n  display: flex;\n  justify-content: center; /* Center the container content horizontally */\n  align-items: center; /* Center items vertically within the container */\n  flex-wrap: nowrap; /* Prevent items from wrapping to the next line */\n  min-height: 100vh;\n  max-width: 100vh;\n}\n\n\n\n\n.App-picture {\n  background-color: #b0e0e6;\n  \n  max-width: 140vh;\n  display: flex;\n  align-items: center; /* Center items vertically within the picture */\n  justify-content: center; /* Center items horizontally within the picture */\n  flex-direction: column;\n  color: black;\n}\n\n\n.App-center {\n  max-width: 90%;\n  background-color: #ffeddd;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center; /* Center vertically */\n  font-size: 20px;\n  padding: 10px; /* Add padding inside the border */\n  margin: 10px; /* Add margin outside the border */\n  text-align: justify; /* Justify text */\n  border-radius: 20px; /* Rounded corners */\n}\n\n.App-center:after {\n  content: '';\n  display: inline-block;\n  width: 100%; /* Ensures the last line is justified */\n}\n\n\n\n\n\n\n.App-button-bar {\n  background-color: #b0e0e6;\n  display: flex; /* Change to flex to use flex properties correctly */\n  flex-direction: column;\n  align-items: center; /* Center items horizontally within the button bar */\n  justify-content: center; /* Center items vertically within the button bar */\n  color: black;\n}\n\n.App-button {\n  background-color: #ffeddd; /* Button background color */\n  border: none;\n  flex-direction: row;\n  padding: 10px; /* Padding inside the button */\n  cursor: pointer; /* Cursor on hover */\n  border-radius: 32px; /* Rounded corners */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 64px; /* Set desired width */\n  height: 64px; /* Set desired height */\n  margin: 5px; /* Adjust the value as needed */\n}\n\n.button-image {\n  width: 40px; /* Adjust size as needed */\n  height: 40px; /* Adjust size as needed */\n}\n\n.App-button:hover {\n  color: #0b55d4; /* Darker color for hover effect */\n}\n\n.content-wrapper {\n  display: flex;\n  align-items: center;\n}\n\n.left-image {\n  width: 250px; /* Adjust the size as needed */\n  height: auto;\n  object-fit: cover;\n  margin-right: 20px; /* Space between image and content */\n  border-radius: 150px; /* Adjust this value for the desired roundness */\n}\n\n.content {\n  font-size: 16px; /* Adjust text size as needed */\n  text-align: left;\n}\n\n.website-text {\n  font-size: 16px; /* Adjust text size as needed */\n  text-align: center;\n}\n\n.cursive-text {\n  font-style: italic; /* Makes the text cursive */\n  font-size: 14px; /* Adjust text size as needed */\n  text-align: left;\n  margin-left:0vh;\n}\n\n\nheader {\n  margin: 0; /* Remove default margin */\n  padding: 10px; /* Optional: Add padding */\n}\n\n\n/* Media query for mobile devices */\n@media (max-width: 768px) {\n  .container {\n    flex-direction: column;\n  }\n\n  .App-center {\n    order: 3;\n    margin-top: 20px;\n  }\n}\n\n\n\n/* Media query for desktop devices */\n@media (min-width: 769px) {\n  .container {\n    flex-direction: row;\n  }\n  .container_small {\n    flex-direction: column;\n    \n  }\n  .App-button-bar {\n    flex-direction: row;\n  }\n  .App-center {\n    order: 2; /* Ensure this comes after .App-picture and .App-button-bar */\n    margin-left: 20px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
